export function formattedPriceUtils(price, currencyCode = '') {
    const exchangeRate = 1.95583; // Fixed BGN to EUR rate

    const symbols = {
        EUR: '€',
        BGN: 'лв.',
    };

    let convertedPrice = parseFloat(price);

    // Ensure conversion only when the target currency is specified
    if (currencyCode === 'EUR') {
        convertedPrice = convertedPrice / exchangeRate;
    } else if (currencyCode === 'BGN') {
        convertedPrice = convertedPrice * exchangeRate;
    }

    // Format to two decimal places
    const formatted = convertedPrice.toFixed(2);
    const [whole, decimal] = formatted.split('.');

    const symbol = symbols[currencyCode] || currencyCode;

    return `${whole}<span class="coins">${decimal}</span> ${symbol}`;
}